import { Component, OnInit } from '@angular/core';
import { AppService } from '../app.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  constructor(private service:AppService,private router:Router) { }

  login=false;
  ngOnInit() {
    if(this.service.isLoggedIn()){
      this.login=true;
    }
  }

  logout(){
    var confirm1=confirm("Are you sure? you want to logout");

    if(confirm1){
      localStorage.removeItem('currentUser');
      this.router.navigateByUrl("/prepaid-recharge");
      return true;
    }else{
      return false;
    }
  }
}
